// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import loadComponents from "gia/loadComponents";
// import config from "gia/config"; // NOT NEEDED ATM

// ——————————————————————————————————————————— IMPORTS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Global Modules //
// import "./modules/globalInit.js";

// Modules //
import ScrollTracker from "./modules/ScrollTracker.js";
// import ScrollTriggers from "./modules/ScrollTrigger.js";

// Init. //
import init_collapsibles from "./init/init_collapsibles.js";
// import init_marquees from "./init/init_marquees.js"; // DEPRECATED

// Components //
import Slideshow from "../site/snippets/blocks/slideshow/js/Slideshow.js";
import Marquee from "../site/snippets/blocks/marquee/js/Marquee.js";
import Calendar from "../site/snippets/calendar/js/Calendar.js";

const comps = {
  Slideshow: Slideshow,
  // Marquee: Marquee,
  Calendar: Calendar,
};

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import consoleStyles from "./assets/consoleStyles.js";

// ———————————————————————————————————————————— INIT. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

/////////// Font-loading ///////////
////////////////////////////////////

document.fonts.ready.then(function () {
  console.log("%cFonts loaded...", consoleStyles.success);
  console.log("%cLoading font-dependent components...", consoleStyles.default);
  loadComponents({ Marquee: Marquee });
});

//////// DOM-content-loaded ////////
////////////////////////////////////

document.addEventListener("DOMContentLoaded", () => {
  console.log("%cDOM content loaded...", consoleStyles.default);

  console.log("%cLoading modules...", consoleStyles.default);
  new ScrollTracker({ log: true });
  // new ScrollTriggers({ log: false });

  console.log("%cLoading components...", consoleStyles.default);
  loadComponents(comps);

  console.log("%cInitializing app...", consoleStyles.default);
  init_collapsibles();

  // console.log("%cPreparing main page content...", consoleStyles.default);
  // const els_mainPageContent = document.querySelectorAll(".main-page-content");
  // const classes = ["tw:group-data-[has-open-overlay=true]/app:opacity-0", "tw:!transition-opacity", "tw:!duration-500"];
  // els_mainPageContent.forEach((el) => el.classList.add(...classes));

  console.log("%cApp initialized!", consoleStyles.success);
});
